import { render } from "./linkTo.vue?vue&type=template&id=6700a728"
import script from "./linkTo.vue?vue&type=script&lang=js"
export * from "./linkTo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__